<!--拷贝销售退换货-->
<template>
  <SelectTableDialog
    :title="$t('logistics.returnOrderTable.Title')"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :API="API"
    :extraData="extraData"
    :confirmUnchecked="false"
    :isMultiple="false"
    width="1200px"
    @close="close"
    @confirm="creatOrder"
  >
  </SelectTableDialog>
</template>

<script>
  import { mapState } from 'vuex';
  import SelectTableDialog from '@/components/SelectTableDialog';
  import API from '@/api/logisticsCenter/logisticsReceiptList.js';
  import BASEAPI from '@/api/dataBase.js';
  export default {
    name: 'returnOrderTable',
    components: {
      SelectTableDialog,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        return [
          {
            prop: 'returnNo',
            name: this.$t('logistics.returnOrderTable.shippingInstructionNo'),
            type: 'input',
          },
          // 部门
          {
            prop: 'returnDepartmentCode',
            name: this.$t('logistics.returnOrderTable.returnDepartmentCode'),
            type: 'treeSelect',
            apiUrl: BASEAPI.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.tenantCode,
              adminFlag: this.userInfo.adminFlag,
            },
            isName: false,
            clearable: false,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('logistics.returnOrderTable.searchTableSpec'),
            prop: 'inboundStorageNo',
            searchType: 'warehouse',
            isMultiple: true,
            getSearchCode: 'storageCode',
          },
          {
            prop: 'compareLessZeroFlag',
            name: this.$t('logistics.logisticsReceiptList.compareLessZeroFlag'),
            type: 'checkbox',
            falseLable: 0,
            trueLable: 1,
            isChecked: true,
          },
          {
            prop: 'compareEqualZeroFlag',
            name: this.$t('logistics.logisticsReceiptList.compareEqualZeroFlag'),
            type: 'checkbox',
            falseLable: 0,
            trueLable: 1,
            isChecked: true,
          },
        ];
      },
      columnList() {
        return [
          {
            prop: 'returnNo',
            label: this.$t('logistics.returnOrderTable.shippingInstructionNo'),
            width: 120,
          },
          {
            prop: 'inboundStorageName',
            label: this.$t('logistics.returnOrderTable.inboundStorageName'),
          },
          {
            prop: 'returnDepartmentName',
            label: this.$t('logistics.returnOrderTable.returnDepartmentName'),
          },
          { prop: 'productDesc', label: this.$t('logistics.returnOrderTable.productDesc') },
          { prop: 'returnQuantity', label: this.$t('logistics.returnOrderTable.returnQuantity') },
          {
            prop: 'remainingNumber',
            label: this.$t('logistics.searchTable.remainingQuantityIn'),
          },
          // { prop: "partnerName", label:this.$t('logistics.returnOrderTable.partnerName') },
          {
            prop: 'returnSalesmanName',
            label: this.$t('logistics.returnOrderTable.returnSalesmanName'),
          },
        ];
      },
    },
    data() {
      return {
        API: API.LIST_ORDER_RETURN_BY_PAGE,
        defaultVisible: false,
        comeFromTypeList: [
          { value: '0', label: this.$t('logistics.returnOrderTable.salesReturn') },
          { value: '1', label: this.$t('logistics.returnOrderTable.salesExchange') },
        ],
        extraData: {
          isDirectDeliver: '0',
        },
      };
    },
    methods: {
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      //跳转编辑页
      creatOrder(selections) {
        if (selections.length !== 0 && selections[0]) {
          this.defaultVisible = false;
          let path = {
            path: '/logistics/logisticsRevise',
            name: 'logisticsRevise',
            meta: {
              keepAlive: true,
              title: this.$t('logistics.logisticsRevise.logisticsRevise'),
            },
            query: {
              instructionNo: selections[0].instructionNo,
              number: '3',
              returnType: selections[0].returnType,
              returnNo: selections[0].returnNo,
              inboundType: 'RK03', //退货
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          this.$message({
            message: this.$t('logistics.returnOrderTable.creatTranstionOrder'),
            type: 'error',
          });
        }
        // else if (selections.length>1) {
        //   this.$message({
        //     message: "不可合并创建",
        //     type: "error"
        //   });
        // }
      },
    },
  };
</script>
